/* ==========================================================================
   wiseXPD collection grid behavior, Polite Worldwide

   Filtering, sorting, the editorial tiles and the favorites, over the cards
   Shopify rendered. Depends on nothing in the POLITE theme.

   Source of truth: clients/polite-worldwide/landing-pages/ in the wisexpd repo.
   ========================================================================== */

(function () {
  var root = document.querySelector('[data-wx-col]');
  if (!root || root.dataset.wxReady === '1') return;
  root.dataset.wxReady = '1';

  var grid = root.querySelector('[data-wx-grid]');
  var moreBtn = root.querySelector('[data-wx-more]');
  var tally = root.querySelector('[data-wx-tally]');
  var empty = root.querySelector('[data-wx-empty]');
  var clearBtn = root.querySelector('[data-wx-clear]');
  var total = Number((tally && tally.dataset.total) || 0);

  var products = [];
  var tiles = [];
  var state = { tab: '*', mat: [], price: [], onlyNew: false, sort: 'featured' };

  // Gold mode, ?metal=gold (the gold email's "Get gold" button). Only pieces
  // with 14k gold in stock, each showing its gold price and linking to the
  // gold variant. The data comes from the card (data-gold-*), in the
  // visitor's own currency, so nothing is priced from silver.
  var goldMode = false;
  try { goldMode = new URLSearchParams(location.search).get('metal') === 'gold'; } catch (e) {}

  function goldCard(cell) {
    var id = cell.dataset.goldId;
    if (!id) return;
    var price = cell.querySelector('.wxc-card__price');
    if (price) price.textContent = 'In 14k gold, from ' + cell.dataset.goldMoney;
    var a = cell.querySelector('.wxc-card__link');
    // Keeps ?view=wx-lp on cards that open our own design; it honors ?variant= too.
    if (a) {
      var h = a.getAttribute('href').replace(/([?&])variant=\d+&?/, '$1').replace(/[?&]$/, '');
      a.href = h + (h.indexOf('?') > -1 ? '&' : '?') + 'variant=' + id;
    }
  }

  try {
    tiles = JSON.parse(root.querySelector('[data-wx-tiles]').textContent) || [];
  } catch (e) {
    tiles = [];
  }

  /* ------------------------------------------------------------- materials */

  // The catalog spells the same three materials twelve different ways
  // ("14kt yellow gold", "14kt Yellow Gold", "14k yellow gold", "Sterling
  // Silver", "sterling silver"). Bucketing here keeps the menu to the three
  // things a customer actually chooses between.
  function bucket(raw) {
    var v = (raw || '').trim().toLowerCase();
    if (!v) return '';
    if (v.indexOf('rose') > -1) return 'Rose gold';
    if (v.indexOf('yellow') > -1) return '14kt yellow gold';
    if (v.indexOf('white') > -1 && v.indexOf('gold') > -1) return '14kt white gold';
    if (v.indexOf('sterling') > -1 || v === 'silver') return 'Sterling silver';
    if (v.indexOf('gold') > -1) return 'Gold';
    return raw.trim().charAt(0).toUpperCase() + raw.trim().slice(1).toLowerCase();
  }

  function readCell(cell) {
    var mats = (cell.dataset.mat || '')
      .split('|')
      .map(bucket)
      .filter(Boolean);
    if (goldMode) goldCard(cell);
    return {
      el: cell,
      gold: !!cell.dataset.goldId,
      pos: Number(cell.dataset.pos || 0),
      type: cell.dataset.type || '',
      title: cell.dataset.title || '',
      price: Number(cell.dataset.price || 0),
      isNew: cell.dataset.new === '1',
      mats: mats.filter(function (m, i) { return mats.indexOf(m) === i; })
    };
  }

  function collect(scope) {
    (scope || grid).querySelectorAll('[data-wx-card]').forEach(function (c) {
      if (c.dataset.wxSeen === '1') return;
      c.dataset.wxSeen = '1';
      products.push(readCell(c));
    });
  }

  /* ----------------------------------------------------------------- tiles */

  function tileEl(t) {
    var cell = document.createElement('div');
    cell.className = 'wxc__cell wxc__cell--tile';

    if (t.kind === 'media') {
      var media = t.video
        ? '<video class="wxc-ed__fill" autoplay muted loop playsinline preload="none"' +
          (t.poster ? ' poster="' + t.poster + '"' : '') + '><source src="' + t.video + '" type="video/mp4"></video>'
        : (t.img ? '<img class="wxc-ed__fill" src="' + t.img + '" alt="' + (t.alt || '') + '" loading="lazy">' : '');
      cell.innerHTML =
        '<div class="wxc-ed wxc-ed--bleed">' + media +
        (t.caption ? '<span class="wxc-ed__caption">' + t.caption + '</span>' : '') +
        (t.url ? '<a class="wxc-ed__link--stretch" href="' + t.url + '" aria-label="' + (t.caption || t.alt || 'View') + '"></a>' +
                 '<span class="wxc-ed__plus" aria-hidden="true">+</span>' : '') +
        '</div>';
    } else {
      // An editorial tile can carry a clip too. The studio tile is a process
      // shot: a still of a bench says less than five seconds of the strand being
      // knotted, which is the whole point of that card.
      var panelMedia = t.video
        ? '<video class="wxc-ed__vid" autoplay muted loop playsinline preload="none"' +
          (t.poster ? ' poster="' + t.poster + '"' : '') +
          '><source src="' + t.video + '" type="video/mp4"></video>'
        : (t.img ? '<img src="' + t.img + '" alt="' + (t.alt || '') + '" loading="lazy">' : '');
      cell.innerHTML =
        '<div class="wxc-ed wxc-ed--panel">' +
        (panelMedia ? '<div class="wxc-ed__media">' + panelMedia + '</div>' : '') +
        '<div class="wxc-ed__body">' +
        (t.title ? '<h2 class="wxc-ed__title">' + t.title + '</h2>' : '') +
        (t.sub ? '<p class="wxc-ed__sub">' + t.sub + '</p>' : '') +
        (t.url && t.linkLabel ? '<span class="wxc-ed__link">' + t.linkLabel + '</span>' : '') +
        '</div>' +
        (t.url ? '<a class="wxc-ed__link--stretch" href="' + t.url + '" aria-label="' + (t.title || 'Discover more') + '"></a>' : '') +
        '</div>';
    }
    return cell;
  }

  /* --------------------------------------------------------------- filters */

  function matches(p) {
    if (goldMode && !p.gold) return false;
    if (state.tab !== '*' && p.type !== state.tab) return false;
    if (state.onlyNew && !p.isNew) return false;
    if (state.mat.length && !state.mat.some(function (m) { return p.mats.indexOf(m) > -1; })) return false;
    if (state.price.length) {
      var ok = state.price.some(function (band) {
        var r = band.split(':');
        return p.price >= Number(r[0]) && p.price < Number(r[1]);
      });
      if (!ok) return false;
    }
    return true;
  }

  function sorted(list) {
    var out = list.slice();
    if (state.sort === 'asc') out.sort(function (a, b) { return a.price - b.price; });
    else if (state.sort === 'desc') out.sort(function (a, b) { return b.price - a.price; });
    else if (state.sort === 'az') out.sort(function (a, b) { return a.title.localeCompare(b.title); });
    else out.sort(function (a, b) { return a.pos - b.pos; });
    return out;
  }

  function render() {
    var visible = sorted(products.filter(matches));

    // Rebuilt rather than reordered, because the editorial tiles have to keep
    // their positions in the run of cards whatever the sort is doing.
    var frag = document.createDocumentFragment();
    var placed = 0;
    var pending = tiles.slice().sort(function (a, b) { return a.after - b.after; });
    // A small collection gets fewer tiles: at most one per eight products, so a
    // tile can never outnumber or crowd the pieces. Collections of 30 or more
    // are unaffected.
    pending = pending.slice(0, Math.floor(visible.length / 8));

    visible.forEach(function (p) {
      frag.appendChild(p.el);
      placed++;
      while (pending.length && pending[0].after <= placed) {
        frag.appendChild(tileEl(pending.shift()));
      }
    });

    // Tiles positioned past the end of a filtered list are dropped rather than
    // piled up at the bottom.
    grid.textContent = '';
    grid.appendChild(frag);

    if (empty) empty.hidden = visible.length > 0;
    if (tally) {
      // Compared against what is actually on the page, not the collection count,
      // because excluded add-ons would otherwise make this read "showing 101 of
      // 103" forever with no filter applied.
      var filtering = state.tab !== '*' || state.onlyNew || state.mat.length || state.price.length;
      tally.textContent = goldMode && !filtering
        ? visible.length + (visible.length === 1 ? ' piece' : ' pieces') + ' in 14k gold'
        : filtering
        ? 'Showing ' + visible.length + ' of ' + products.length
        : products.length + (products.length === 1 ? ' piece' : ' pieces');
    }
    var active = state.tab !== '*' || state.onlyNew || state.mat.length || state.price.length;
    if (clearBtn) clearBtn.hidden = !active;
    paintFavourites();
  }

  /* ------------------------------------------------------------ favorites */

  function readFavs() {
    try {
      return JSON.parse(localStorage.getItem('wx-polite-favs') || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeFavs(list) {
    try {
      localStorage.setItem('wx-polite-favs', JSON.stringify(list));
    } catch (e) { /* private window, or site data blocked */ }
  }

  function paintFavourites() {
    var favs = readFavs();
    grid.querySelectorAll('[data-wx-fav]').forEach(function (b) {
      b.setAttribute('aria-pressed', favs.indexOf(b.dataset.wxFav) > -1 ? 'true' : 'false');
    });
  }

  /* ------------------------------------------------------------- load more */

  var loading = false;

  function loadNext() {
    var url = moreBtn && moreBtn.dataset.next;
    if (!url || loading) return Promise.resolve(false);
    loading = true;
    moreBtn.textContent = 'Loading';

    return fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-wx-card]').forEach(function (c) {
          var cell = document.importNode(c, true);
          cell.dataset.wxSeen = '1';
          products.push(readCell(cell));
        });
        var nextBtn = doc.querySelector('[data-wx-more]');
        moreBtn.dataset.next = (nextBtn && nextBtn.dataset.next) || '';
        moreBtn.hidden = !moreBtn.dataset.next;
        moreBtn.textContent = 'Load more';
        loading = false;
        buildMaterialMenu();
        render();
        return true;
      })
      .catch(function () {
        loading = false;
        moreBtn.textContent = 'Load more';
        return false;
      });
  }

  function loadAllThen(fn) {
    // A filter over half the catalog is a wrong answer, so anything that
    // narrows the grid pulls the rest of the pages in first.
    if (!moreBtn || !moreBtn.dataset.next) { fn(); return; }
    (function step() {
      loadNext().then(function (more) {
        if (more && moreBtn.dataset.next) step();
        else fn();
      });
    })();
  }

  /* ----------------------------------------------------------------- menus */

  function buildMaterialMenu() {
    var host = root.querySelector('[data-wx-build="mat"]');
    if (!host) return;
    var counts = {};
    products.forEach(function (p) {
      p.mats.forEach(function (m) { counts[m] = (counts[m] || 0) + 1; });
    });
    var names = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
    host.innerHTML = names.length
      ? names.map(function (n) {
          return '<button class="wxc__opt" type="button" role="checkbox" aria-checked="' +
            (state.mat.indexOf(n) > -1) + '" data-wx-filter="mat" data-wx-value="' + n + '">' +
            '<span class="wxc__box" aria-hidden="true"></span><span>' + n + '</span>' +
            '<span class="wxc__count">' + counts[n] + '</span></button>';
        }).join('')
      : '<p class="wxc__opt">No materials listed</p>';
  }

  function closeMenus(except) {
    root.querySelectorAll('[data-wx-menu]').forEach(function (m) {
      if (m === except) return;
      m.hidden = true;
      var btn = root.querySelector('[data-wx-toggle="' + m.dataset.wxMenu + '"]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function toggleList(list, value) {
    var i = list.indexOf(value);
    if (i > -1) list.splice(i, 1);
    else list.push(value);
  }

  /* --------------------------------------------------------------- wiring */

  root.addEventListener('click', function (e) {
    var t = e.target;

    var toggle = t.closest('[data-wx-toggle]');
    if (toggle) {
      var menu = root.querySelector('[data-wx-menu="' + toggle.dataset.wxToggle + '"]');
      var willOpen = menu.hidden;
      closeMenus(menu);
      menu.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', String(willOpen));
      return;
    }

    var fav = t.closest('[data-wx-fav]');
    if (fav) {
      e.preventDefault();
      // The wishlist script, when it is on the page, owns the list: it writes
      // the same localStorage key at once, then does the Klaviyo half (the
      // email panel, the Added to Wishlist event) in the background. Without
      // it, the heart works exactly as it always did, on this device only.
      if (window.wxWishlist && typeof window.wxWishlist.toggle === 'function') {
        var cell = fav.closest('[data-wx-card]');
        var added = window.wxWishlist.toggle(fav.dataset.wxFav, {
          source: 'grid',
          variant: goldMode && cell ? cell.dataset.goldId : ''
        });
        fav.setAttribute('aria-pressed', added ? 'true' : 'false');
        return;
      }
      var favs = readFavs();
      toggleList(favs, fav.dataset.wxFav);
      writeFavs(favs);
      fav.setAttribute('aria-pressed', favs.indexOf(fav.dataset.wxFav) > -1 ? 'true' : 'false');
      return;
    }

    var tab = t.closest('[data-wx-tab]');
    if (tab) {
      root.querySelectorAll('[data-wx-tab]').forEach(function (b) {
        b.setAttribute('aria-selected', String(b === tab));
      });
      state.tab = tab.dataset.wxTab;
      loadAllThen(render);
      return;
    }

    var opt = t.closest('[data-wx-filter]');
    if (opt) {
      var key = opt.dataset.wxFilter;
      var val = opt.dataset.wxValue;
      if (key === 'new') state.onlyNew = !state.onlyNew;
      else toggleList(state[key], val);
      opt.setAttribute('aria-checked', String(
        key === 'new' ? state.onlyNew : state[key].indexOf(val) > -1
      ));
      loadAllThen(render);
      return;
    }

    var sortOpt = t.closest('[data-wx-sort]');
    if (sortOpt) {
      state.sort = sortOpt.dataset.wxSort;
      root.querySelectorAll('[data-wx-sort]').forEach(function (b) {
        b.setAttribute('aria-checked', String(b === sortOpt));
      });
      closeMenus();
      loadAllThen(render);
      return;
    }

    if (t.closest('[data-wx-clear]')) {
      state = { tab: '*', mat: [], price: [], onlyNew: false, sort: state.sort };
      root.querySelectorAll('[aria-checked]').forEach(function (b) {
        if (!b.dataset.wxSort) b.setAttribute('aria-checked', 'false');
      });
      root.querySelectorAll('[data-wx-tab]').forEach(function (b, i) {
        b.setAttribute('aria-selected', String(i === 0));
      });
      render();
      return;
    }

    if (t.closest('[data-wx-more]')) { loadNext(); return; }

    if (!t.closest('[data-wx-menu]')) closeMenus();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenus();
  });

  // A save or remove made anywhere else (a product page heart, the wishlist
  // page, another tab) repaints the hearts here.
  document.addEventListener('wx:wishlist', paintFavourites);
  window.addEventListener('storage', function (e) {
    if (e.key === 'wx-polite-favs') paintFavourites();
  });

  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) closeMenus();
  });

  collect();
  buildMaterialMenu();
  render();
  if (goldMode) loadAllThen(render);
})();
